/* Sam Al Oud — theme behaviour
   Cart drawer, AJAX add to cart, variant picker, mobile menu. No dependencies. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = window.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas);
  }

  /* ---------- panels ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim'), mob = $('#mob');

  function openBag() { drawer.classList.add('on'); scrim.classList.add('on'); }
  function closeBag() { drawer.classList.remove('on'); if (!mob || !mob.classList.contains('on')) scrim.classList.remove('on'); }
  function openMob() { mob.classList.add('on'); scrim.classList.add('on'); }
  function closeMob() { mob.classList.remove('on'); if (!drawer.classList.contains('on')) scrim.classList.remove('on'); }
  function closeAll() { closeBag(); closeMob(); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#bagBtn')) { e.preventDefault(); openBag(); }
    if (e.target.closest('[data-close-bag]')) closeBag();
    if (e.target.closest('#burger')) openMob();
    if (e.target.closest('#mobX')) closeMob();
    if (e.target.closest('[data-close-all]')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---------- cart ---------- */
  function renderCart(cart) {
    var body = $('#dbody'); if (!body) return;

    var count = $('#bagCount');
    if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }

    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p>Your bag is empty.</p>' +
        '<a class="btn btn-line" href="' + (window.Shopify ? '/collections/all' : '#') + '">Browse the oils</a></div>';
    } else {
      body.innerHTML = cart.items.map(function (item, i) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        return '<div class="line" data-line="' + (i + 1) + '">' +
          '<div class="line-i" style="background-image:url(' + img + ')"></div>' +
          '<div>' +
            '<a class="line-n" href="' + item.url + '">' + item.product_title + '</a>' +
            '<div class="line-s">' + (item.variant_title || '') + '</div>' +
            '<div class="qty">' +
              '<button type="button" data-qty="' + (item.quantity - 1) + '" aria-label="Less">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty="' + (item.quantity + 1) + '" aria-label="More">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="line-p">' + money(item.final_line_price) + '</div>' +
        '</div>';
      }).join('');
    }

    var sub = $('#subtotal'); if (sub) sub.textContent = money(cart.total_price);

    var threshold = window.freeShipThreshold || 0;
    var msg = $('#shipMsg'), bar = $('#shipBar');
    if (msg && bar && threshold > 0) {
      var left = Math.max(0, threshold - cart.total_price);
      msg.textContent = left > 0 ? money(left) + ' more for free shipping' : 'Free shipping unlocked';
      bar.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }
  }

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(id, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || 'Could not add that'); return null; }
        return getCart().then(function (cart) { openBag(); return cart; });
      })
      .catch(function () { toast('Network error — please try again'); });
  }

  function changeLine(line, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  /* quick add on product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    addToCart(btn.dataset.variantId, 1).then(function () {
      btn.disabled = false; btn.textContent = original;
    });
  });

  /* quantity controls inside the drawer */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.qty button');
    if (!q) return;
    var row = q.closest('[data-line]');
    changeLine(parseInt(row.dataset.line, 10), parseInt(q.dataset.qty, 10));
  });

  /* ---------- product page ---------- */
  var productSection = $('[data-product]');
  if (productSection) {
    var select = $('#VariantId', productSection);

    // gallery thumbnails
    $$('.thumb', productSection).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $('#pShot', productSection).style.backgroundImage = 'url(' + thumb.dataset.thumb + ')';
        $$('.thumb', productSection).forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
      });
    });

    // option buttons -> matching variant
    function currentOptions() {
      return $$('.sizes', productSection).map(function (group) {
        var on = $('.size.on', group);
        return on ? on.dataset.value : null;
      });
    }

    function syncVariant() {
      var wanted = currentOptions().join(' / ');
      var match = $$('option', select).filter(function (o) { return o.dataset.options === wanted; })[0];
      var button = $('[data-add-button]', productSection);
      var price = $('#pPrice', productSection);

      if (!match) {
        button.disabled = true;
        button.textContent = 'Unavailable';
        return;
      }
      select.value = match.value;
      if (price) price.textContent = match.dataset.price;
      var available = match.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to bag' : 'Sold out';

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('.sizes', productSection).forEach(function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('.size');
        if (!b) return;
        $$('.size', group).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        syncVariant();
      });
    });

    // add to cart without leaving the page
    var form = $('#ProductForm', productSection);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = $('[data-add-button]', productSection);
        var label = button.textContent;
        button.disabled = true; button.textContent = 'Adding…';
        addToCart(select.value, 1).then(function () {
          button.disabled = false; button.textContent = label;
        });
      });
    }
  }

  /* ---------- hero carousel ---------- */
  var carousel = $('[data-carousel]');
  if (carousel) {
    var slides = $$('.hero-slide', carousel);
    var dotsBox = $('[data-dots]', carousel);
    var current = 0;
    var timer;

    function goTo(i) {
      slides[current].classList.remove('on');
      if (dotsBox) dotsBox.children[current].classList.remove('on');
      current = i;
      slides[current].classList.add('on');
      if (dotsBox) dotsBox.children[current].classList.add('on');
    }
    function next() { goTo((current + 1) % slides.length); }
    function restart() { clearInterval(timer); timer = setInterval(next, 4500); }

    if (slides.length > 1) {
      if (dotsBox) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          if (i === 0) b.classList.add('on');
          b.setAttribute('aria-label', 'Show photo ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); restart(); });
          dotsBox.appendChild(b);
        });
      }
      restart();
    }
  }

  /* ---------- email popup ---------- */
  var popupCard = $('#popupCard');
  if (popupCard) {
    var popupScrim = $('#popupScrim');
    var delay = parseInt(popupCard.dataset.delay || '4', 10) * 1000;
    var dismissedKey = 'samAlOudPopupDismissed';
    var alreadyDismissed = false;
    try { alreadyDismissed = window.localStorage.getItem(dismissedKey) === '1'; } catch (e) {}

    function openPopup() {
      popupCard.classList.add('on');
      popupScrim.classList.add('on');
    }
    function closePopup(remember) {
      popupCard.classList.remove('on');
      popupScrim.classList.remove('on');
      if (remember) {
        try { window.localStorage.setItem(dismissedKey, '1'); } catch (e) {}
      }
    }

    if (!alreadyDismissed) {
      setTimeout(openPopup, delay);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupCard.classList.contains('on')) closePopup(true);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) closePopup(true);
    });

    var popupForm = $('#PopupNewsletter');
    if (popupForm) {
      popupForm.addEventListener('submit', function () {
        try { window.localStorage.setItem(dismissedKey, '1'); } catch (e) {}
      });
    }
  }

  /* ---------- boot ---------- */
  if (window.Shopify && window.Shopify.routes) {
    getCart();
  }
})();
